import { Action, ActionReducerMapBuilder, AnyAction, PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../config/Api";
import { Page, ProductDetail, ProductDetailRes, ProductRes, ProductResDto } from "../../types/productType";



export const fetchProductById = createAsyncThunk<ProductResDto,number>("product/fetchProductById",async(productId,{rejectWithValue})=>{
    try {
        const response = await api.get(`/products/${productId}`)
      

        return response.data as ProductResDto
    } catch (error:any) {
        console.error(error);
        return rejectWithValue(error.message || "Failed to fetch product");
    }
})
export const fetchProductDetailById = createAsyncThunk<ProductDetailRes,number>("product/fetchProductDetailById",async(detailId,{rejectWithValue})=>{
  try {
      const response = await api.get(`/products/productDetail/${detailId}`)
      return response.data as ProductDetailRes
  } catch (error:any) {
      console.error(error);
      return rejectWithValue(error.message || "Failed to fetch product");
  }
})
export const searchProduct = createAsyncThunk<ProductRes[],string>("product/searchProduct",async(query,{rejectWithValue})=>{
    try {
        const response = await api.get(`/products/search`,{
            params:{
                query
            }
        })
       
        return response.data
    } catch (error) {
        console.error(error)
    }
})

export const fetchAllProduct = createAsyncThunk<Page<ProductResDto>,any>("product/fetchAllProduct",async(params,{rejectWithValue})=>{
    try {
        const response = await api.get(`/products`,{
            params:{
              ...params,// Spread operator handles undefined/null gracefully
                pageNumber:params.pageNumber||0
            }
        })
        
        return response.data
    } catch (error) {
        console.error(error)
    }
})

export const fetchSimilarProducts = createAsyncThunk<ProductRes[],{categoryId: string,pageNumber: number}>("product/fetchSimilarProducts",async({categoryId,pageNumber},{rejectWithValue})=>{
  try {
      const response = await api.get(`/products`,{
          params:{
              categoryId,// Spread operator handles undefined/null gracefully
              pageNumber:pageNumber||0
          }
      })
      
      return response.data.content
  } catch (error) {
      console.error(error)
      return rejectWithValue
  }
})
export const getProductsByCategoryId = createAsyncThunk<Page<ProductResDto>,{categoryId:string,pageNumber:number}>("product/getProductsByCategoryId",async({categoryId,pageNumber},{rejectWithValue})=>{
  try {
    const response = await api.get("/products/categoryId",{
      params:{
        categoryId,
        pageNumber:pageNumber||0
      }
    })
console.log("response.data: ",response.data);
    return response.data
  } catch (error:any) {
    console.error(error)
      return rejectWithValue(error.message||"Failed to load products")
  }
})
interface ProductState{
    categoryProducts: ProductResDto[],
    categoryTotalPages:number,
    entities: Record<number,ProductResDto>,
    currentId?:number,
    product?:ProductResDto|null;
    products:ProductResDto[];
    totalPages:number;
    loading:boolean;
    error:string|null|undefined;
    searchProduct:ProductRes[],
    similarProduct:ProductRes[],
    entitiesDetails: Record<number,ProductDetail>
    productDetail?:ProductDetail,
    currentDetailId?:number
}

const initialState:ProductState={
    categoryProducts: [],
    entities:{},
    product:null,
    currentId:undefined,
    products:[],
    totalPages:1,
    loading:false,
    error:null,
    searchProduct:[],
    similarProduct:[],
    entitiesDetails:{},
    categoryTotalPages:1
}

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: { 
    setCurrentProduct(state, action: PayloadAction<number | undefined>) {
      const id = action.payload;
      state.currentId = id;
      state.product = id ? state.entities[id] : undefined;
    },
    setCurrentDetail(state, action: PayloadAction<number | undefined>) {
      const id = action.payload;
      state.currentDetailId = id;
      state.productDetail = id ? state.entitiesDetails[id] : undefined;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<ProductState>) => {
    // Fetch Product by ID
    builder
      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductById.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.entities[payload.id] = payload;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    //fetch product detail by id
    .addCase(fetchProductDetailById.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchProductDetailById.fulfilled, (state, {payload}) => {
      state.loading = false;
      state.entitiesDetails[payload.id] = payload;
      
    })
    .addCase(fetchProductDetailById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    }) 

    // Search Products
    
      .addCase(searchProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchProduct.fulfilled, (state, action: PayloadAction<ProductRes[]>) => {
        state.loading = false;
        state.searchProduct = action.payload;
      })
      .addCase(searchProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

    // Fetch All Products
   
      .addCase(fetchAllProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllProduct.fulfilled, (state, {payload}:PayloadAction<Page<ProductResDto>>) => {
        state.loading = false;
        state.products = payload.content;
        state.totalPages = payload.totalPages
      })
      .addCase(fetchAllProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getProductsByCategoryId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductsByCategoryId.fulfilled, (state, action: PayloadAction<Page<ProductResDto>>) => {
        state.loading = false;
        state.categoryProducts = action.payload.content;
        state.categoryTotalPages = action.payload.totalPages
      
      })
      .addCase(getProductsByCategoryId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      //fetchSimilarProducts

      .addCase(fetchSimilarProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSimilarProducts.fulfilled, (state, action: PayloadAction<ProductRes[]>) => {
        state.loading = false;
        state.similarProduct = action.payload.slice(1);
      })
      .addCase(fetchSimilarProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

      
  },
});
export const { setCurrentProduct,setCurrentDetail } = productSlice.actions; 
export const productSliceReducer = productSlice.reducer

 
 